export default __webpack_public_path__ + "static/NotoSans-ExtraLightItalic-0d7df33224dfbecd5627a37e8d52a47f.ttf";